import { paymentMethodStatusValue } from "@redotech/redo-billing-common/payment-method-status";
import * as z from "zod";

export const getPaymentMethodStatus = {
  name: "getPaymentMethodStatus" as const,
  input: z.object({}),
  output: z.object({
    paymentMethodStatus: z.object({
      primary: paymentMethodStatusValue,
      secondary: paymentMethodStatusValue,
    }),
  }),
};
